// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'babel-polyfill'
//全局样式
import "../src/assets/css/base.css";
import "../src/assets/css/m.css";
// import "../src/assets/js/mob-share"
import Print from 'vue-print-nb'
import  '@/utils/dateUtil'
import '@/icons'
Vue.use(Print); //注册

Vue.config.productionTip = false
Vue.use(ElementUI);

import config from '../static/config/config';
window.publicPath =config.serverIP
let script = document.createElement('script')
script.type = 'text/javascript'
script.src = 'http://f1.webshare.mob.com/code/mob-share.js?appkey=2f0d5f822e505'
script.id = '-mob-share'
document.body.appendChild(script)


router.beforeEach((to, from, next) => {
  window.scrollTo(0,0);
  next();
});

window.vueRef =new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js